import React, { Component } from 'react';
import * as yup from 'yup';
import { message } from 'antd';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import RightSlider from '../../Common/RightSlider';
import dclogo from "../../../../Assets/images/doodycalls.png";
import {map} from "lodash";


class Login extends Component {

  state = {
    email: '',
    password: '',
    loader: false,
    rememberUser: false,
    validPassword: {
      containsUppercase: false,
      containsNumber: false,
      checkLength: false,
    },
    is_btn_active: false,
    errors: {}
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    // message.destroy();
    // Register User Response
    if (Object.keys(props.Login.data).length > 0 && props.Login.data !== this.props.Login.data) {
      // display Success messsage

      if (props.Login.data?.user?.role.includes('service_rep')) {
        window.location.assign('/case-management');
      }
      else {
        window.location.assign('/dashboard');
      }

    }
    if (Object.keys(props.Login.errors).length > 0 && props.Login.errors !== this.props.Login.errors) {
      // display error messsage
      this.setState({ loader: false });
      message.error(props.Login.errors.non_field_errors && props.Login.errors.non_field_errors, 10);
      Cookies.remove('Secure-SSID_REMEMBER', { path: '' });
    }
  }

  componentDidMount = () => {
    const Secure = Cookies.get('Secure-SSID_REMEMBER')
      ? JSON.parse(Cookies.get('Secure-SSID_REMEMBER'))
      : "";
    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).key
      : "";
    if (accessToken) {
      this.props.history.push('/dashboard')
    }

    if (Secure) {
      this.setState({
        rememberUser: true,
        email: Secure.email,
        password: Secure.password,
        validPassword: Secure.validPassword,
        is_btn_active: true
      })
    }
    this.wrapperRef.focus();

  }

  //set user name and password
  onUserChange = (e) => {
    let { validPassword } = this.state;
    if (e.target.name === 'password') {
      validPassword = Object.assign(validPassword, {
        'containsUppercase': (/[A-Z]/).test(e.target.value),
        'containsNumber': (/\d/).test(e.target.value),
        'checkLength': e.target.value.length >= 8,
      });
    }
    this.setState({
      [e.target.name]: e.target.value,
      validPassword,
    }, /*this.validateUser(this.state.validPassword)*/)
  }

  //login User
  Login = (e) => {
    e.preventDefault();
    let { email, password, rememberUser,validPassword } = this.state;
    if (rememberUser) {
      Cookies.set('Secure-SSID_REMEMBER', JSON.stringify({ 'rememberUser': rememberUser, "email": email, "password": password,"validPassword":validPassword }));
    }
    else {
      Cookies.remove('Secure-SSID_REMEMBER', { path: '' });
    }

    // call login API
    let is_crm = true;
    this.props.userLogin({ email, password, is_crm })
    this.setState({ loader: true })
  }

  // Validate Form
  validateUser = (e) => {
    e.preventDefault();
    let { email, password, validPassword } = this.state;
    const UserSchema = yup.object().shape({
      email: yup.string().required("Email is required").email('Your Email is invalid.'),
      password: yup.string().required("Password is required"),
      validPassword: yup.object().shape({
        containsUppercase: yup.bool().oneOf([true], 'Password contains one uppercase letter'),
        containsNumber: yup.bool().oneOf([true], 'Password contains number'),
        checkLength: yup.bool().oneOf([true], 'Minimum length is 8')
      })
    })

    const UserData = {
      email, password,
      validPassword
    }

    UserSchema.validate(UserData, { abortEarly: false }).then(() => {
      this.setState({is_btn_active: true, errors: {}});
      this.Login(e)
    }).catch((error) => {
      let err_data = {};
      map(error.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data, is_btn_active: false})
    });
  }
  
  //remember
  onRemember = (e) => {
    if (e.target.checked) {
      this.setState({
        rememberUser: e.target.checked,
      })
    }
    else {
      this.setState({
        rememberUser: e.target.checked,
      });
      Cookies.remove('Secure-SSID_REMEMBER', { path: '' });
    }
  }

  render() {
    let { email, password, loader, rememberUser, errors } = this.state;
    return (
      <div id="wrapper">
        <div className="auth-page">
          <div className="authform">
            <div className="auth-container">
              <img src={dclogo} alt="" className="logo" />
              <h1>Welcome to DoodyCalls CRM.<br />Sign in to see your latest updates.</h1>
              <label className="mb-30">Enter your details to proceed</label>
              <form className="form-group" onSubmit={(e) => this.validateUser(e)}>
                <div className="fitem">
                  <label>Email</label>
                  <input
                    type='email'
                    name='email'
                    value={email}
                    onChange={(e) => { this.onUserChange(e) }}

                    ref={(input) => { this.wrapperRef = input; }}
                    placeholder="Email" />
                  {errors?.['email'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['email']}</label> : ''}
                </div>
                <div className="fitem">
                  <label>Password</label>
                  <input
                    type="password"
                    name="password"
                    value={password}
                    onChange={(e) => { this.onUserChange(e) }}
                    placeholder="Start typing…" />
                  {(errors?.['password'] || errors?.['validPassword.containsUppercase'] ||
                    errors?.['validPassword.checkLength'] || errors?.['validPassword.containsNumber']) ? <label className="new_err_msg"><i className="las la-info-circle"/>{'Invalid password'}</label> : ''}
                </div>
                <div className="fitem half-fitem inline-check-list flex">
                  <div className="fitem-check">
                    <input type="checkbox"
                      className="fitem-ck-input"
                      id="checkbox"
                      checked={rememberUser}
                      onChange={(e) => { this.onRemember(e) }}
                      name="checkboxs" />
                    <label htmlFor="checkbox" className="fitem-ck-txt">Remember me</label>
                  </div>
                  <Link to="/forgot-password" replace className="m-0"><strong><u>Recover Password</u></strong></Link>
                </div>
                <div className="btn-grp text-right">
                  <button type="submit" className={'btn btn-primary'}>Sign In</button>
                </div>
              </form>
            </div>
          </div>
          <RightSlider />
        </div>
        {
          loader ?
            <div className='loader_wrapper'>
              <div className='loader07'></div>
            </div>
            : ''
        }
      </div>
    );
  }
}

export default Login;